import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import _ from "lodash";
import { Dropdown, Menu, Divider, Icon, Tooltip, Modal, Button } from "antd";
import Status from "components/status/Status.js";
import AuthRender from "../../../../../containers/AuthRender";
import { ACCESS, SERVICES } from "../../../../../configs/constants";

const { confirm } = Modal;
export const surveyColumns = (setArchiveSurvey, getSurveySorted, deleteSurvey) => [
  {
    title: "Nom",
    dataIndex: "surveylabel",
    key: "surveylabel",
    sortable: true,
    sorter: 1,
    onHeaderCell: () => {
      return {
        onClick: () => {
          getSurveySorted("surveylabel");
        }
      };
    }
  },
  {
    title: "Statut",
    dataIndex: "status.label",
    key: "status.label",
    sortable: true,
    sorter: 1,
    render: (text, record, index) => {
      return <Status statusId={record.status.id} />;
    },
    onHeaderCell: () => {
      return {
        onClick: () => {
          getSurveySorted("status.label");
        }
      };
    }
  },
  {
    title: "Période",
    dataIndex: "surveyPeriodicity",
    key: "surveyPeriodicity",
    sortable: true,
    sorter: 0,
    render: (text, record, index) => {
      return (
        <Fragment>
          {record.SurveyPeriodicity && (
            <div>
              {moment(record.SurveyPeriodicity.startDate).format("DD/MM/YY")}
              {` - `}
              {moment(record.SurveyPeriodicity.endDate).format("DD/MM/YY")}
            </div>
          )}
        </Fragment>
      );
    }
  },
  {
    title: "Création",
    dataIndex: "created_at",
    key: "created_at",
    sortable: true,
    sorter: 1,
    render: (text, record, index) => <div>{moment(text).format("DD/MM/YY")}</div>,
    onHeaderCell: () => {
      return {
        onClick: () => {
          getSurveySorted("created_at");
        }
      };
    }
  },
  {
    title: "Kpis",
    dataIndex: "kpis",
    key: "kpis",
    render: (text, record, index) => {
      

      if (!_.get(record, "metier.locationTypes") || !Array.isArray(record.metier.locationTypes)) return null;
      let nbKpis = 0;
      return (
        <Dropdown
          overlay={
            <Menu>
              {record.metier.locationTypes.map(locationType => {
                return (
                  <Menu.SubMenu title={locationType.label}>
                    {locationType.statements &&
                      locationType.statements.map(statement => {
                        const listMenuItem = [];

                        statement.kpis.map((kpi, k) => {
                          nbKpis++;
                          if (k === 0) {
                            listMenuItem.push(
                              <Menu.Item
                                title={
                                  statement.condition
                                    ? `question affichée pour l'action : ${statement.question}`
                                    : "pas de question 'condition' pour remplir les kpis de cette action"
                                }
                              >
                                <span
                                  style={
                                    statement.displayType === "matrix" ? { color: "#42d1b7" } : { color: "#d14260" }
                                  }
                                >
                                  {statement.label && statement.label.toUpperCase()}
                                  {statement.displayType === "matrix" ? " (Matrice)" : " (En ligne)"}
                                  {` - ${statement.id}`}
                                </span>
                              </Menu.Item>
                            );
                          }

                          listMenuItem.push(
                            <Menu.Item
                              title={
                                statement.displayType === "matrix"
                                  ? `label affiché : ${kpi.short_label}`
                                  : `question affichée: ${kpi.question}`
                              }
                            >
                              - {kpi.id} : {kpi.long_label} (source : {kpi.source} / format : {kpi.format} / priorité :{" "}
                              {kpi.priority} / min : {Array.isArray(kpi.rules) ? kpi.rules[0] : "-"} / max :{" "}
                              {Array.isArray(kpi.rules) ? kpi.rules[1] : "-"})
                            </Menu.Item>
                          );
                        });
                        return listMenuItem;
                      })}
                  </Menu.SubMenu>
                );
              })}
            </Menu>
          }
        >
          <a className="ant-dropdown-link">
            {nbKpis} kpi{nbKpis <= 1 ? "" : "s"}
          </a>
        </Dropdown>
      );
    }
  },
  {
    title: "Modèles",
    dataIndex: "model.assortmentLabel",
    key: "assortmentId",
    sortable: true,
    sorter: 1,
    onHeaderCell: () => {
      return {
        onClick: () => {
          getSurveySorted("model.assortmentLabel");
        }
      };
    }
  },
  {
    title: "Enseigne",
    dataIndex: "retailer.retailerName",
    key: "retailer.retailerName",
    sortable: true,
    sorter: 1,
    onHeaderCell: () => {
      return {
        onClick: () => {
          getSurveySorted("retailer.retailerName");
        }
      };
    }
  },
  {
    title: "Périmètre",
    dataIndex: "sector_label",
    key: "sector_label",
    render: (text, record, index) => {
      const { sectors } = record;
      const regionales = record.regionales || [];
      const pdcs = record.pdcs || [];

      return (
        <Fragment>
          {!_.isEmpty(sectors) && (
            <Dropdown
              overlay={
                <Menu>
                  {sectors.map((sector, index) => (
                    <Menu.Item key={index}>{sector.label}</Menu.Item>
                  ))}
                </Menu>
              }
            >
              <a className="ant-dropdown-link">{sectors.length} secteur(s)</a>
            </Dropdown>
          )}
          {!_.isEmpty(regionales) && (
            <div style={{ marginTop: sectors && sectors.length > 0 ? 5 : 0 }}>
              <Dropdown
                overlay={
                  <Menu>
                    {regionales.map((sector, index) => (
                      <Menu.Item key={index}>{sector.label}</Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <a className="ant-dropdown-link">
                  {regionales.length}{" "}
                  {`centrale${regionales.length > 1 ? "s" : ""} régionale${regionales.length > 1 ? "s" : ""}`}
                </a>
              </Dropdown>
            </div>
          )}
          {_.isEmpty(regionales) && _.isEmpty(sectors) && !_.isEmpty(pdcs) && (
            <div>
              <a className="ant-dropdown-link">
                {pdcs.length} {`PDC`}
              </a>
            </div>
          )}
        </Fragment>
      );
    }
  },
  {
    title: "Actions",
    dataIndex: "actions",
    key: "actions",
    sortable: false,
    render: (text, record, index) => {
      //Go see statusFormat object in Status component to see correspondance of the id
      const recordIdDuplicateAvailable = [1, 2, 4];
      const linkToDuplicate = {
        pathname: "/survey/creation",
        params: { duplicate: 1 },
        state: { survey: record }
      };

      return (
        <Fragment>
          {recordIdDuplicateAvailable.includes(record.status.id) && (
            <Link to={linkToDuplicate}>
              <Tooltip placement="top" title={"Dupliquer"}>
                <Icon type="copy" style={{ fontSize: 14, color: "#000000" }} />
              </Tooltip>
            </Link>
          )}
          {record.status.id === 2 && (
            <Fragment>
              <Divider type="vertical" />
              <a
                onClick={() => {
                  confirm({
                    title: "Confirmation",
                    content: `Voulez-vous vraiment archiver le questionnaire ${record.surveylabel} ?`,
                    onOk: () => {
                      setArchiveSurvey({ surveyId: record.surveyId });
                    },
                    onCancel() {}
                  });
                }}
              >
                <Tooltip placement="top" title={"Archiver"}>
                  <Icon type="database" style={{ fontSize: 14, color: "#000000" }} />
                </Tooltip>
              </a>
            </Fragment>
          )}
          {record.deletable && (
            <AuthRender service={SERVICES.Formulaire} access={[ACCESS.suppression]}>
              <Fragment>
                <Divider type="vertical" />
                <a
                  onClick={() => {
                    //setArchiveSurvey({ surveyId: record.surveyId });
                    confirm({
                      title: "Confirmation",
                      content: `Voulez-vous vraiment supprimer le questionnaire ${record.surveylabel} ?`,
                      onOk() {
                        deleteSurvey(record._id);
                      },
                      onCancel() {}
                    });
                  }}
                >
                  <Tooltip placement="top" title={"Supprimer"}>
                    <Icon type="delete" style={{ fontSize: 14, color: "#000000" }} />
                  </Tooltip>
                </a>
              </Fragment>
            </AuthRender>
          )}
        </Fragment>
      );
    }
  }
];

export const rangeDatePickerFilter = {
  label: "SurveyPeriodicity",
  targetKey: "SurveyPeriodicity",
  placeholder: "Période"
};

export const surveyFilters = [
  {
    label: "retailer",
    targetKey: "retailer.retailerName",
    placeholder: "Enseignes",
    defaultValue: "retailer.retailerName"
  },
  {
    label: "sectors",
    targetKey: "sectors.label",
    placeholder: "Secteur",
    defaultValue: "sectors.label"
  }
];



// WEBPACK FOOTER //
// src/components/survey/gestion/SurveyList/SurveyListGrid/SurveyListGrid.utils.js